import {
	spNavigationHomeLocMap,
	spNavigationHomeLocs,
	SpNavigationHomeLocs,
} from './home/sp-home-nav-locs';

/**
 * When setting up locs for navigation, place the file in a folder matching the parent menu item.
 * Name each file after the menu item. If too many files are created,
 * add a subfolder and continue the pattern.
 */

export type SpNavigationLocs = SpNavigationHomeLocs;

export const spNavigationLocs = {
	...spNavigationHomeLocs,
};

export const spNavigationLocMap: Record<string, SpNavigationLocs> = {
	...spNavigationHomeLocMap,
};
